/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Enum to distinguish different categories of emails.
 */
export enum EnumEmailCategory {
    /**
     * Default fallback value.
     */
    NotDefined = 0,
    /**
     * Emails connected to invoices
     */
    Invoice = 1,
    /**
     * Emails connected to orders
     */
    Order = 2,
    /**
     * Emails connected to registration
     */
    Invitation = 3,
    /**
     * Emails connected to password resets
     */
    PasswordReset = 4,
    /**
     * Emails mirroring in-app notifications (e.g. invoice batch results)
     */
    Notification = 5,
}
